/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { View, Text } from 'react-native';
import { KdsTimerMilestone } from '@oolio-group/domain';
import { useTranslation } from '@oolio-group/localization';
import { useSession } from '../../hooks/useSession';
import SettingsScreenStyles from './Settings.styles';
import SettingsItem from '../../component/SettingsItem/SettingsItem';
import SetTimerModal, {
  TimerAction,
} from '../../component/Modals/Timer/SetTimerModal';
import SettingsAction from '../../component/SettingsItem/SettingsAction';
import { useKitchenDisplay } from '../../hooks/useKitchenDisplay';
import { stripProperties } from '@oolio-group/client-utils';

const KitchenTimerSettings: React.FC = () => {
  const styles = SettingsScreenStyles();
  const { translate } = useTranslation();
  const { session, setSession } = useSession();
  const [timerModalVisible, setTimerModalVisible] = useState(false);

  const [editIndex, setEditIndex] = useState<number | undefined>(undefined);

  const { updateKitchenDisplay } = useKitchenDisplay({
    storeId: session?.currentStore?.id,
  });

  const milestones = (session?.kitchenDisplay?.timerMilestones || []).map(
    (x: KdsTimerMilestone) => stripProperties(x, '__typename'),
  ) as KdsTimerMilestone[];

  const closeTimerModalModal = () => {
    setTimerModalVisible(false);
  };
  const openTimerModal = (index?: number) => {
    setEditIndex(index);
    setTimerModalVisible(true);
  };

  const onSaveMilestone = (milestone: KdsTimerMilestone) => {
    const isExisting =
      editIndex !== undefined
        ? milestones
            .filter((_, index) => index !== editIndex)
            .some(x => {
              return (
                x.color === milestone.color ||
                x.minutes === milestone.minutes ||
                x.label === milestone.label
              );
            })
        : milestones.some(x => {
            return (
              x.color === milestone.color ||
              x.minutes === milestone.minutes ||
              x.label === milestone.label
            );
          });

    if (isExisting) {
      window.alert('Name/Minutes/Color of Timer already exists');

      return;
    }

    if (editIndex === undefined) {
      updateKitchenDisplay({
        id: session?.kitchenDisplay?.id || '',
        timerMilestones: [...milestones, milestone].sort(
          (a, b) => a.minutes - b.minutes,
        ),
      });
      setSession({
        kitchenDisplay: {
          ...session.kitchenDisplay,
          timerMilestones: [...milestones, milestone].sort(
            (a, b) => a.minutes - b.minutes,
          ),
        },
      });
    } else {
      updateKitchenDisplay({
        id: session?.kitchenDisplay?.id || '',
        timerMilestones: milestones.map((item, index) =>
          index === editIndex ? milestone : item,
        ),
      });
      setSession({
        kitchenDisplay: {
          ...session.kitchenDisplay,
          timerMilestones: milestones.map((item, index) =>
            index === editIndex ? milestone : item,
          ),
        },
      });
    }
    setTimerModalVisible(false);
    setEditIndex(undefined);
  };
  const onDeleteMilestone = () => {
    if (editIndex === undefined) return;

    updateKitchenDisplay({
      id: session?.kitchenDisplay?.id || '',
      timerMilestones: milestones.filter((_, index) => index !== editIndex),
    });
    setSession({
      kitchenDisplay: {
        ...session.kitchenDisplay,
        timerMilestones: milestones.filter((_, index) => index !== editIndex),
      },
    });

    setTimerModalVisible(false);
    setEditIndex(undefined);
  };

  return (
    <>
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>
          {translate('kitchenDisplay.timerPreference')}{' '}
        </Text>
        {milestones.map((entry, index) => {
          return (
            <SettingsItem
              key={index}
              type="action"
              testID={'message-on-bump'}
              title={entry.label}
              subtitle={`${entry.minutes} Mins`}
              indicatorColor={entry.color}
              onChange={() => openTimerModal(index)}
            />
          );
        })}
        <View style={{ height: 16 }} />
        <SettingsAction
          type="positive"
          testID="btn-add-timer"
          onPress={() => openTimerModal()}
          label={'Create Timer'}
        />
      </View>

      <SetTimerModal
        key={`timer${timerModalVisible}${editIndex}`}
        visible={timerModalVisible}
        action={editIndex !== undefined ? TimerAction.EDIT : TimerAction.CREATE}
        onClose={closeTimerModalModal}
        onSave={onSaveMilestone}
        onDelete={onDeleteMilestone}
        milestone={editIndex !== undefined ? milestones[editIndex] : undefined}
      />
    </>
  );
};

export default KitchenTimerSettings;
